import type { Release } from '../releases.ts';

export default {
  version: '0.17.4',
  date: '2026-10-02',
  title: 'Phone recordings at 25 fps on iPhone',
  summary: [
    'Fixed: Record video on an iPhone records at 25 fps when chosen, though Safari keeps the camera at 30',
  ],
  features: [],
  fixes: ['Record video on an iPhone records at 25 fps when 25 fps is chosen: Safari keeps the camera at 30 fps, so PRISM records the picture at 25 fps itself and shows “camera 30 fps, recorded at 25”'],
} satisfies Release;
